import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Input from '../Input';
import ErrorTooltip from '../ErrorTooltip';

const EditableField = ({
  defaultValue, formatter, onSave, maxValue, minValue,
}) => {
  const defaultValueString = (defaultValue || '').toString();
  const [value, setValue] = useState(defaultValueString);
  const [isEditing, setIsEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const linkClasses = 'underline text-theme text-xs font-bold focus:outline-none';
  const handleSaveClick = () => {
    let error = null;
    if (Number.isNaN(value)) {
      error = 'Please enter correct payment amount.';
    } else if (minValue > 0 && value < minValue) {
      error = `Payment amount can not less than deposit amount $${minValue}`;
    } else if (maxValue > 0 && value > maxValue) {
      error = `Payment amount should not exceed total amount $${maxValue}`;
    }

    if (error) {
      setErrorMessage(error);
      setTimeout(() => {
        setErrorMessage(null);
      }, 3000);
      return;
    }
    setErrorMessage(null);
    onSave(+value);
    setIsEditing(false);
  };

  const handleCloseClick = () => {
    setErrorMessage(null);
    setIsEditing(false);
    setValue(defaultValueString);
  };

  const handleInputValueChange = (event) => {
    const newValue = event.target.value;
    if (!Number.isNaN(+newValue)) {
      setValue(newValue);
    }
  };

  return isEditing ? (
    <>
      <ErrorTooltip
        title={errorMessage || ''}
        open={!!errorMessage}
        arrow
        placement="top"
        PopperProps={{ disablePortal: true }}
      >
        <div>
          <Input
            type="text"
            onClick={() => setErrorMessage(null)}
            onChange={handleInputValueChange}
            value={value}
            autoFocus
          />
        </div>
      </ErrorTooltip>
      <div className="text-center">
        <button type="button" onClick={handleCloseClick} className={clsx(linkClasses, 'mr-4')}>
          Cancel
        </button>
        <button
          type="button"
          onClick={handleSaveClick}
          className={linkClasses}
        >
          Save
        </button>
      </div>
    </>
  ) : (
    <div>
      <div>
        {formatter ? formatter(value) : value}
      </div>
      <div>
        <button type="button" onClick={() => { setIsEditing(true); }} className={linkClasses}>
          Edit amount
        </button>
      </div>
    </div>
  );
};

EditableField.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  formatter: PropTypes.func,
  onSave: PropTypes.func.isRequired,
};

EditableField.defaultProps = {
  formatter: undefined,
  maxValue: 0,
  minValue: 0,
};

export default memo(EditableField);
